import React from 'react';
import styles from '../../styles.css';
import indicatorsStyles from './styles.css';
import { default as SubIndicators } from '../SubIndicators/index.jsx';

import { isSearchedPhrase } from '../../utils';
import HighlightText from '../../HighlightText.jsx';

const hasSelectedDescendants = (item, selectedSubjects) => {
	if (!item.childrens) return false;
	return item.childrens.some(
		(child) => selectedSubjects.includes(child.id) || hasSelectedDescendants(child, selectedSubjects),
	);
};

export default function Indicators({
	indicators,
	nestedListsToShow,
	showNestedLists,
	selectedSubjects,
	onSubjectSelect,
	subjectColor,
	isSimplifiedView,
	subjectParent,
	queryParams,
	searchPhrase,
	onSubjectChange,
}) {
	return indicators.map((indicator, index) => {
		let disableExpandButton = false;

		let subjectWithNoChildren = false;

		let subjectsGroup = [];

		const getSubjectChildrens = (childrens) => {
			childrens.forEach((child) => {
				if (child.childrens) {
					getSubjectChildrens(child.childrens);
				}
				subjectsGroup.push(child.fullName);
			});
		};

		indicator.childrens ? getSubjectChildrens(indicator.childrens) : (subjectWithNoChildren = true);

		const descendantsSelected = !isSimplifiedView && hasSelectedDescendants(indicator, selectedSubjects);

		subjectsGroup.forEach((children) => {
			if (
				isSearchedPhrase({
					subjectName: children,
					phrase: searchPhrase,
				})
			) {
				disableExpandButton = true;
			}
		});

		return (
			<li
				key={`${indicator.fullName.split(' ').join('')}_${index}`}
				className={`${indicatorsStyles.level3} ${
					!isSimplifiedView && selectedSubjects.includes(indicator.id)
						? `${indicatorsStyles.selectedItem} ${subjectParent}`
						: ''
				}`}
			>
				<a
					onClick={(e) => {
						if (isSimplifiedView && onSubjectChange) {
							e.preventDefault();
							onSubjectChange(indicator.id);
						}
						if (!isSimplifiedView) {
							e.preventDefault();
							onSubjectSelect(indicator.id);
						}
					}}
					href={`/measures/${indicator.id.toLowerCase()}.html`}
					className={`${
						isSearchedPhrase({
							subjectName: indicator.fullName,
							phrase: searchPhrase,
						})
							? styles.highlightSearchedWord
							: ''
					} ${indicatorsStyles.level3Item} ${indicatorsStyles.indicatorPill} ${styles.subjectName} ${
						!isSimplifiedView && selectedSubjects.includes(indicator.id)
							? `${indicatorsStyles.selected} ${subjectParent}`
							: ''
					}`}
				>
					<HighlightText text={indicator.fullName} phrase={searchPhrase} />
				</a>
				<span
					className={indicatorsStyles.appMenuLevel3Expand}
					style={subjectWithNoChildren ? { visibility: 'hidden' } : undefined}
				>
					{!nestedListsToShow.includes(indicator.id) ? (
						<span
							className={`${indicatorsStyles.expandButton} ${descendantsSelected ? indicatorsStyles.expandButtonActive : ''}`}
							onClick={() => {
								if (!subjectWithNoChildren) {
									showNestedLists((displayedRows) => [...displayedRows, indicator.id]);
								}
							}}
						>
							{/* eslint-disable-next-line i18next/no-literal-string */}
							{'+'}
						</span>
					) : (
						<span
							className={`${indicatorsStyles.expandButton} ${disableExpandButton ? indicatorsStyles.disabled : ''} ${descendantsSelected ? indicatorsStyles.expandButtonActive : ''}`}
							onClick={() => {
								if (disableExpandButton) {
									return;
								}
								showNestedLists((displayedRows) => displayedRows.filter((item) => item !== indicator.id));
							}}
						>
							<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.5 6H9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
							</svg>
						</span>
					)}
				</span>

				{indicator?.childrens ? (
					<SubIndicators
						subIndicators={indicator?.childrens}
						indicatorId={indicator.id}
						showNestedLists={showNestedLists}
						nestedListsToShow={nestedListsToShow}
						selectedSubjects={selectedSubjects}
						onSubjectSelect={onSubjectSelect}
						subjectColor={subjectColor}
						isSimplifiedView={isSimplifiedView}
						subjectParent={subjectParent}
						queryParams={queryParams}
						searchPhrase={searchPhrase}
						onSubjectChange={onSubjectChange}
					/>
				) : null}
			</li>
		);
	});
}
